import React, { useEffect, useState } from 'react';
import { Grid, Paper } from '@mui/material';
const BaleLumpView = () => {
    const [formData, setFormData] = useState([]);
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);
    // console.log(formData)
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }}>
                        <h3 className='centered-heading'>Bale & Lump View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            {formData.length > 0 ?
                                (
                                    formData?.map((item, index) => (
                                        <>
                                            <tr>
                                                <td>
                                                    <h3>Bale Details</h3>
                                                    <table>
                                                        <thead>
                                                            <th>Sr.No.</th>
                                                            <th>Bale</th>
                                                            <th>Mtr.</th>
                                                            <th>Rack</th>
                                                        </thead>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.bale}</td>
                                                            <td>{item.mtr}</td>
                                                            <td>{item.rack}</td>
                                                        </tr>

                                                    </table>
                                                </td>

                                                <td>
                                                    <h3>Lump Details</h3>
                                                    <table>
                                                        <thead>
                                                            <th>Sr.No.</th>
                                                            <th>Location</th>
                                                            <th>Rack</th>
                                                            <th>Barcode</th>
                                                            <th>Color</th>
                                                            <th>mtr</th>
                                                        </thead>
                                                        <tbody>
                                                            {item?.lump.length > 0 &&
                                                                item?.lump?.map((val, valIndex) => (
                                                                    <tr key={valIndex}>
                                                                        <td>{valIndex + 1}</td>
                                                                        <td>{val.locNm !== null ? val.locNm : ''}</td>
                                                                        <td>{val.rack}</td>
                                                                        <td>{val.barcode}</td>
                                                                        <td>{val.color}</td>
                                                                        <td>{val.lumpmtr}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>

                                            </tr>

                                        </>
                                    ))
                                ) : null}
                        </table>
                    </div>
                </Paper>
            </Grid>

        </>
    );
};

export default BaleLumpView;
